module.exports = __webpack_public_path__ + "img/KubeOperator-assist-white.551855b5.png";